module.exports = __webpack_public_path__ + "static/billsbot-india-a1ffbd063f99acb7d95176fc272fcc48.svg";